import { Progress } from "@/components/ui/progress";

// New Order:
// 0: Leiloeiro
// 1: Fotos
// 2: Dados do Veículo
// 3: Cadastro
// 4: Resultado
// 5: Plano

// We only show progress up to step 4 (Resultado). Step 5 is post-analysis
const TOTAL_PROGRESS_STEPS = 5;

const STEP_LABELS = [
  "Leiloeiro",
  "Fotos",
  "Veículo",
  "Cadastro",
  "Resultado",
  "Plano",
];

interface Props {
  currentStep: number;
}

export function SimulatorStepper({ currentStep }: Props) {
  // Cap at 100% and avoid showing "Plano" as a progress step in the same way
  const progressStep = Math.min(currentStep, TOTAL_PROGRESS_STEPS - 1);
  const pct = (progressStep / (TOTAL_PROGRESS_STEPS - 1)) * 100;

  return (
    <div className="w-full space-y-3">
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground font-medium">
          Etapa {progressStep + 1} de {TOTAL_PROGRESS_STEPS}
        </span>
        <span className="font-bold text-foreground">
          {STEP_LABELS[currentStep]}
        </span>
      </div>
      <Progress value={pct} className="h-2 bg-muted/30" />
    </div>
  );
}

